export const LOGIN_USER = "LOGIN_USER";
export const GET_ERRORS = "GET_ERRORS"